import { InjectionToken } from '@angular/core';
import { BaseApiClientEmployeesService } from '../base-api-client-employees.service';

export const API_CLIENT_EMPLOYEES_SERVICE = new InjectionToken<BaseApiClientEmployeesService>(
  'BaseApiClientEmployeesService'
);